const DEFAULT = 0

/**
 * Ширина заливки звёзд для `stars_rate`.
 *
 * Оценка сначала округляется математически до одного знака (0,5 вверх).
 */
export default function filterStarsProgress(value: number, starsCount: number = 5) {
  if (value < 0 || value > starsCount) {
    return DEFAULT
  }

  const marginRight = 0.25
  const widthFillable = 0.62
  const widthStroke = 1 - widthFillable
  const valueRounded = Math.round(value * 10) / 10
  const integerStars = Math.floor(valueRounded)
  const fractionalStars = valueRounded % 1

  return integerStars * (1 + marginRight) + widthStroke / 2 + fractionalStars * widthFillable
}
